import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { CommonService } from '../../../_common/_service/user.service';


@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {
  token: any;
  constructor(private tokenStorageService: TokenStorageService, private _service: CommonService, private router: Router) { }

  ngOnInit() {
    this.token = this.tokenStorageService.getToken();


  }

  Back() {

    this.router.navigate(['/Go-on']);
  }

  contactInfo = {
    address: 'Biznetmart India Pvt Ltd: Plot No. 713, 2nd Floor, Niti Khand-1, Indirapuram, Ghaziabad U.P. 201014',
    phone: '+91 97195 05011',
    email: 'info@iripash.com',
  };

  socialLinks = [
    { icon: 'fab fa-facebook-f', link: 'https://www.facebook.com' },
    { icon: 'fab fa-twitter', link: 'https://www.twitter.com' },
    { icon: 'fab fa-linkedin', link: 'https://www.linkedin.com' },
    { icon: 'fab fa-instagram', link: 'https://www.instagram.com' },
  ];

  closeSidebar() {
    // Logic to close the sidebar
    console.log('Sidebar closed');
  }
}
